import React, { useState, useRef } from 'react';
import { motion, useSpring } from 'framer-motion';
interface Card3DProps {
  children: React.ReactNode;
  className?: string;
}
export function Card3D({
  children,
  className = ''
}: Card3DProps) {
  const cardRef = useRef<HTMLDivElement>(null);
  const [isHovering, setIsHovering] = useState(false);
  const rotateX = useSpring(0, {
    stiffness: 200,
    damping: 20
  });
  const rotateY = useSpring(0, {
    stiffness: 200,
    damping: 20
  });
  const shadowX = useSpring(0, {
    stiffness: 200,
    damping: 20
  });
  const shadowY = useSpring(4, {
    stiffness: 200,
    damping: 20
  });
  const handleMouseMove = (e: React.MouseEvent<HTMLDivElement>) => {
    if (!cardRef.current) return;
    const rect = cardRef.current.getBoundingClientRect();
    const centerX = rect.left + rect.width / 2;
    const centerY = rect.top + rect.height / 2;
    const mouseX = e.clientX - centerX;
    const mouseY = e.clientY - centerY;
    const maxTilt = 8;
    const tiltX = -(mouseY / (rect.height / 2)) * maxTilt;
    const tiltY = mouseX / (rect.width / 2) * maxTilt;
    rotateX.set(tiltX);
    rotateY.set(tiltY);
    shadowX.set(tiltY * 0.5);
    shadowY.set(4 + Math.abs(tiltX) * 0.5);
  };
  const handleMouseLeave = () => {
    setIsHovering(false);
    rotateX.set(0);
    rotateY.set(0);
    shadowX.set(0);
    shadowY.set(4);
  };
  return <motion.div ref={cardRef} onMouseMove={handleMouseMove} onMouseEnter={() => setIsHovering(true)} onMouseLeave={handleMouseLeave} style={{
    perspective: 800,
    rotateX,
    rotateY,
    transformStyle: 'preserve-3d'
  }} className={`will-change-transform ${className}`} data-id="element-17">
      <div className={`transition-shadow duration-200 ${isHovering ? 'shadow-xl' : 'shadow-md'}`} data-id="element-18">
        {children}
      </div>
    </motion.div>;
}